import React from "react"
import { motion } from "framer-motion"

const CARDS = [
  {
    title: "Education",
    items: [
      {
        role: "BSc (Hons) Computing",
        org: "London Metropolitan University, delivered at Informatics College Pokhara",
        date: "Feb 2021 – Dec 2024",
      },
      { role: "+2 Science", org: "Motherland Secondary School" },
    ],
  },
  {
    title: "Certifications",
    items: [
      { role: "MERN Stack", org: "ClinchTech", date: "2023" },
      { role: "AWS Academy Cloud Foundations", org: "AWS Academy" },
    ],
  },
  {
    title: "Achievements",
    items: [{ role: "Full scholarship, 1st year", org: "AAA Scholarship — Bachelor's Degree" }],
  },
]

const LANGUAGES = [
  { name: "English", level: "FLUENT" },
  { name: "Nepali", level: "NATIVE" },
  { name: "Hindi", level: "FLUENT" },
  { name: "German", level: "A1" },
]

export default function Education() {
  return (
    <section id="education" className="bg-ink text-white border-t border-lineSoft py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-baseline gap-3.5 mb-10">
          <span className="font-mono text-xs text-amber">04</span>
          <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">
            Education & credentials
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mb-5">
          {CARDS.map((card, i) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="bg-panel border border-line p-6"
            >
              <h3 className="font-mono text-xs tracking-widest text-muted2 uppercase mb-4">
                {card.title}
              </h3>
              <div className="space-y-4">
                {card.items.map((it) => (
                  <div key={it.role}>
                    <div className="font-display font-semibold text-[15px]">{it.role}</div>
                    <div className="font-mono text-xs text-muted mt-0.5">{it.org}</div>
                    {it.date && <div className="font-mono text-[11px] text-muted2 mt-0.5">{it.date}</div>}
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.4, delay: 0.24 }}
          className="bg-panel border border-line p-6 max-w-sm"
        >
          <h3 className="font-mono text-xs tracking-widest text-muted2 uppercase mb-4">Languages</h3>
          {LANGUAGES.map((l, i) => (
            <div
              key={l.name}
              className={`flex justify-between text-sm py-2.5 ${
                i !== LANGUAGES.length - 1 ? "border-b border-lineSoft" : ""
              }`}
            >
              <span>{l.name}</span>
              <span className="font-mono text-[11px] text-muted2">{l.level}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
